export const MAX_XLSX_PREVIEW_ROWS = 1000;
export const MAX_XLSX_PREVIEW_COLS = 60;
